import { faBookOpen } from '@fortawesome/pro-solid-svg-icons';
import { Callout, Code, Text } from '@scale/scaleui-radix';
import { CompassInstructions } from '@scale/compass-ui/components/CardInstructions';

export const JoinCardInstructions = () => {
  return (
    <CompassInstructions
      header="How to use the Join Data card"
      storageKey="joinCardInstructionsExpanded"
      disableCollapse={true}
      icon={faBookOpen}
    >
      <Callout.Text>
        <Text as="p">
          <div className="text-sm text-gray-600">
            This card will join additional data to your compass table based on your selected
            columns.
            <ul className="list-disc ml-6 my-2">
              <li>The previous table must contain a column with the corresponding base IDs.</li>
              <li>The data will be returned in the columns named in the selection table.</li>
              <li>The same number of rows will be returned as the previous table.</li>
              <li>Existing columns will be overwritten with new data from the join source.</li>
              <li>
                Selecting data from more data sources may make the retrieval process take longer.
              </li>
            </ul>
            <Text as="p">
              Currently supported IDs: <Code>workerId</Code>
            </Text>
          </div>
        </Text>
      </Callout.Text>
    </CompassInstructions>
  );
};
